import {initActions} from '@dized/ui/dist/redux/ActionHelper';
import {call} from '@dized/ui/dist/redux/RequestHelper';

export default initActions('ShellActions', {
  SHOW_ASSET_EXPLORER: (item) => call(item),
  DISMISS_ASSET_EXPLORER: () => call(),
});
